import classes from "../classes";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import expandable from "./higher-order/expandable";
import findBet from "../find-bet";
import horseRunningSmall from "../../public/images/horse-running-small.gif";
import pure from "./higher-order/pure";
import React from "react";
import WagerPadLightbox from "./wager-pad-lightbox";

export default pure(function PlayFieldRaceEntrantPick({ bets, disabled, onMakeAlternatePick, onMakePick, pendingPicks, race, raceEntrant, raceEntrants, savedPicks, ticket, tournament }) {
  if (tournament.get("real_money")) {
    return (
      <PlayFieldRaceEntrantPickLiveBankroll race={race} raceEntrant={raceEntrant} raceEntrants={raceEntrants} ticket={ticket} tournament={tournament} />
    );
  }
  var tournamentId = tournament.get("id");

  var bet = findBet(bets, race.get("id"), ticket.get("id"));
  var primaryPickId, alternatePickId;
  if (bet) {
    primaryPickId = bet.get("race_entrant_id");
    alternatePickId = bet.get("alternate_pick_id");
  }
  var isPrimaryPick = primaryPickId === raceEntrant.get("id") || raceEntrants.getIn([primaryPickId, "lane_number"]) === raceEntrant.get("lane_number");
  var isAlternatePick = alternatePickId === raceEntrant.get("id") || raceEntrants.getIn([alternatePickId, "lane_number"]) === raceEntrant.get("lane_number");

  if (ticket.get("eliminated_by_race_id") !== null) {
    disabled = true;
  }

  var pendingPickRaceEntrantId = pendingPicks.get(ticket.get("id"));
  if (pendingPickRaceEntrantId) {
    disabled = true;
    var isExactPick = pendingPickRaceEntrantId === raceEntrant.get("id");
    if (isExactPick) {
      return (
        <div className="game-table_cell game-table_cell--ticket" onClick={(e) => e.stopPropagation()}>
          <span>
            <img className="loading" src={horseRunningSmall} />
          </span>
        </div>
      );
    }
  }
  if (savedPicks.get(ticket.get("id")) === raceEntrant.get("id")) {
    return (
      <div className="game-table_cell game-table_cell--ticket" onClick={(e) => e.stopPropagation()}>
        <TransitionGroup>
          <CSSTransition
            classNames="game-table_cell--ticket"
            timeout={{enter: 500, exit: 500}}>
            <span className="color--is-lime text--is-bold text-tiny js-success-gif">
              <i className="dw-checkmark3 dw--1-25x" />

              {" "}
              Saved!
            </span>
          </CSSTransition>
        </TransitionGroup>
      </div>
    );
  }

  var alternateDisabled = disabled || isPrimaryPick || primaryPickId === undefined;

  function pickPrimary(e) {
    e.stopPropagation();
    if (disabled || isPrimaryPick) {
      return;
    }
    onMakePick(ticket.get("id"), tournamentId, race.get("id"), raceEntrant.get("id"), isAlternatePick ? undefined : alternatePickId);
  }
  function pickAlternate(e) {
    e.stopPropagation();
    if (alternateDisabled || isAlternatePick) {
      return;
    }
    onMakeAlternatePick(ticket.get("id"), tournamentId, race.get("id"), primaryPickId, raceEntrant.get("id"));
  }

  var runnerLabel = "Horse";

  if (race.get("track_breed_type") === "Greyhound") {
    runnerLabel = "Greyhound";
  }

  return (
    <div className="game-table_cell game-table_cell--ticket" onClick={(e) => e.stopPropagation()}>
      <div className="btn_group btn_group--sleek btn_group--stacked-mobile">
        <div className="btn_group_item">
          <button
            className={classes({
              "btn": true,
              "btn--small": true,
              "btn--is-selected": isPrimaryPick,
              "btn--is-disabled": disabled,
              "tooltip": !disabled
            })}
            data-tooltip={"Pick \"" + raceEntrant.get("horse_name") + "\" as your Primary " + runnerLabel + " for this Ticket."}
            onClick={pickPrimary}
            type="button">
            P
          </button>
        </div>

        <div className="btn_group_item">
          <button
            className={classes({
              "btn": true,
              "btn--small": true,
              "btn--is-selected": isAlternatePick,
              "btn--is-disabled": alternateDisabled,
              "tooltip": !alternateDisabled
            })}
            data-tooltip={"Pick \"" + raceEntrant.get("horse_name") + "\" as your Alternate " + runnerLabel + " for this Ticket."}
            onClick={pickAlternate}
            type="button">
            A
          </button>
        </div>
      </div>
    </div>
  );
});

var PlayFieldRaceEntrantPickLiveBankroll = pure(expandable(function PlayFieldRaceEntrantPickLiveBankroll({ expanded, race, raceEntrant, raceEntrants, ticket, toggle, tournament }) {
  var lightbox;
  if (expanded) {
    lightbox = <WagerPadLightbox onClose={toggle} race={race} raceEntrant={raceEntrant} raceEntrants={raceEntrants} ticket={ticket} tournament={tournament} />;
  }
  return (
    <div className="game-table_cell game-table_cell--ticket game-table_cell--ticket-md" onClick={toggle}>
      {lightbox}

      <button className="btn btn--small tooltip" data-tooltip="Launch wager pad." type="button">
        Place Wager
      </button>
    </div>
  );
}));
